
export const styleSheet = () => ({
  globalFooterArea:{
      position:'sticky',
      bottom:'0px',
    }
  })